export const tvSeries = [
  {
    id: 1,
    title: '庆余年第二季',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 9.3,
    episodes: 36,
    year: 2024,
    status: '已完结',
    actors: '张若昀、李沁、陈道明、吴刚',
    director: '孙皓',
    description: '范闲从北齐归来后，面临着更加复杂的朝堂局势和江湖纷争。在庆帝的注视下，他必须在权力与道义之间做出选择，同时还要守护身边的人。一场关乎天下苍生的博弈悄然展开。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20historical%20drama%20poster%20featuring%20a%20lone%20warrior%20in%20traditional%20black%20robe%20standing%20on%20ancient%20palace%20rooftops%20under%20moonlight%2C%20ink%20wash%20painting%20style%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20dark%20warm%20tones%20with%20deep%20red%20accents%2C%20misty%20mountains%20in%20background%2C%20high%20detail%20artistic%20rendering&width=600&height=800&seq=tv-cover-01&orientation=portrait',
    featured: true,
    tags: ['古装', '权谋', '武侠', '热门'],
  },
  {
    id: 2,
    title: '狂飙',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 9.5,
    episodes: 39,
    year: 2023,
    status: '已完结',
    actors: '张译、张颂文、李一桐、张志坚',
    director: '徐纪周',
    description: '以一线刑警安欣与黑恶势力长达二十年的生死搏斗为主线，展现扫黑除恶专项斗争的艰辛历程。剧中人物命运交织，正义与邪恶的较量扣人心弦。',
    coverUrl: 'https://readdy.ai/api/search-image?query=An%20intense%20Chinese%20crime%20drama%20poster%20with%20two%20men%20facing%20each%20other%20in%20contrasting%20light%20and%20shadow%2C%20one%20in%20police%20uniform%20silhouette%2C%20the%20other%20in%20dark%20civilian%20clothes%2C%20urban%20night%20cityscape%20background%20with%20neon%20reflections%2C%20cinematic%20film%20noir%20style%2C%20dramatic%20chiaroscuro%20lighting%2C%20warm%20amber%20and%20cool%20teal%20tones&width=600&height=800&seq=tv-cover-02&orientation=portrait',
    featured: true,
    tags: ['刑侦', '扫黑', '现实题材', '热播'],
  },
  {
    id: 3,
    title: '繁花',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 9.1,
    episodes: 30,
    year: 2024,
    status: '已完结',
    actors: '胡歌、马伊琍、唐嫣、辛芷蕾',
    director: '王家卫',
    description: '九十年代的上海，青年阿宝凭借改革开放的春风和自己的智慧努力拼搏，从平凡走向传奇。在商海沉浮中，他经历了财富的起落和情感的纠葛，最终领悟到人生的真谛。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20nostalgic%201990s%20Shanghai%20drama%20poster%20featuring%20an%20elegant%20man%20in%20vintage%20suit%20walking%20through%20neon-lit%20Nanjing%20Road%20at%20night%2C%20art%20deco%20architecture%2C%20golden%20warm%20lighting%2C%20cinematic%20Wong%20Kar-wai%20aesthetic%2C%20dreamy%20bokeh%20effects%2C%20rich%20amber%20and%20emerald%20tones%2C%20sophisticated%20retro%20atmosphere&width=600&height=800&seq=tv-cover-03&orientation=portrait',
    featured: true,
    tags: ['年代剧', '商战', '爱情', '经典'],
  },
  {
    id: 4,
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'hanju',
    rating: 9.2,
    episodes: 16,
    year: 2023,
    status: '已完结',
    actors: '宋慧乔、李到晛、林智妍、廉惠兰',
    director: '安吉镐',
    description: '年少时遭受校园暴力的文东恩，经过多年的精心策划，开始向当年的施暴者和旁观者展开一场冷酷而完美的复仇。每一个棋子都在她的掌控之中。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20revenge%20thriller%20poster%20with%20a%20woman%20in%20elegant%20black%20attire%20standing%20before%20a%20Go%20board%2C%20cold%20expression%2C%20split%20lighting%20creating%20dramatic%20shadows%2C%20minimal%20composition%2C%20cool%20midnight%20blue%20and%20icy%20white%20tones%2C%20sophisticated%20thriller%20aesthetic%2C%20high%20fashion%20editorial%20style&width=600&height=800&seq=tv-cover-04&orientation=portrait',
    featured: true,
    tags: ['复仇', '悬疑', '校园暴力', '热门'],
  },
  {
    id: 5,
    title: '眼泪女王',
    category: '韩剧',
    categorySlug: 'hanju',
    rating: 8.8,
    episodes: 16,
    year: 2024,
    status: '已完结',
    actors: '金秀贤、金智媛、朴成焄、郭东延',
    director: '张英宇',
    description: '顶级百货女王洪海仁与超市王子白贤宇结婚三年后，婚姻走到了尽头。然而命运的转折让两人重新审视彼此，在笑声与泪水中重新找回爱情的故事。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20drama%20poster%20with%20an%20elegant%20couple%20in%20formal%20attire%20standing%20back%20to%20back%2C%20soft%20champagne%20and%20rose%20gold%20color%20palette%2C%20luxurious%20hotel%20lobby%20background%2C%20warm%20romantic%20lighting%2C%20dreamy%20atmosphere%2C%20cinematic%20soft%20focus%2C%20emotional%20tension%20expressed%20through%20body%20language&width=600&height=800&seq=tv-cover-05&orientation=portrait',
    featured: false,
    tags: ['爱情', '喜剧', '豪门', '治愈'],
  },
  {
    id: 6,
    title: '龙之家族',
    category: '美剧',
    categorySlug: 'meiju',
    rating: 8.7,
    episodes: 10,
    year: 2024,
    status: '更新中',
    actors: '马特·史密斯、艾玛·达西、奥利维亚·库克',
    director: '克莱尔·基尔纳',
    description: '坦格利安王朝的鼎盛时期，王室内部分裂导致了被称为"血龙狂舞"的内战。巨龙翱翔于天空，铁王座之争让整个维斯特洛大陆陷入战火。',
    coverUrl: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20drama%20poster%20with%20a%20massive%20dragon%20silhouette%20circling%20a%20medieval%20castle%20under%20stormy%20skies%2C%20fire%20and%20smoke%2C%20dark%20steel%20and%20crimson%20tones%2C%20dramatic%20epic%20scale%2C%20cinematic%20fantasy%20aesthetic%2C%20powerful%20and%20majestic%20atmosphere&width=600&height=800&seq=tv-cover-06&orientation=portrait',
    featured: true,
    tags: ['奇幻', '史诗', '权谋', '特效'],
  },
  {
    id: 7,
    title: '最后生还者',
    category: '美剧',
    categorySlug: 'meiju',
    rating: 9.0,
    episodes: 9,
    year: 2023,
    status: '已完结',
    actors: '佩德罗·帕斯卡、贝拉·拉姆齐',
    director: '克雷格·麦辛',
    description: '末日世界，真菌感染将人类变成了可怕的怪物。坚强的幸存者乔尔受雇将14岁女孩艾莉从隔离区偷运出去。一段跨越废墟美国的旅程，改变了两个人的命运。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20drama%20poster%20with%20a%20rugged%20man%20and%20young%20girl%20walking%20through%20an%20overgrown%20abandoned%20city%2C%20nature%20reclaiming%20buildings%2C%20warm%20golden%20hour%20light%20piercing%20through%20ruins%2C%20cinematic%20composition%2C%20olive%20green%20and%20rust%20tones%2C%20emotional%20journey%20atmosphere&width=600&height=800&seq=tv-cover-07&orientation=portrait',
    featured: false,
    tags: ['末日', '冒险', '剧情', '游戏改编'],
  },
  {
    id: 8,
    title: '三体',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 8.5,
    episodes: 30,
    year: 2023,
    status: '已完结',
    actors: '张鲁一、于和伟、陈瑾、王子文',
    director: '杨磊',
    description: '纳米科学家汪淼在警官史强的邀请下，进入了一个神秘的网络游戏"三体"，揭开了一个外星文明的面纱。人类文明面临着前所未有的危机与抉择。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20drama%20poster%20featuring%20cosmic%20scale%20with%20three%20suns%20in%20strange%20orbits%20above%20a%20desolate%20planet%2C%20a%20lone%20figure%20staring%20at%20the%20sky%2C%20deep%20space%20background%20with%20stars%2C%20dark%20blue%20and%20violet%20cosmic%20tones%2C%20mysterious%20and%20philosophical%20atmosphere%2C%20hard%20sci-fi%20aesthetic&width=600&height=800&seq=tv-cover-08&orientation=portrait',
    featured: false,
    tags: ['科幻', '悬疑', '刘慈欣', '硬核'],
  },
  {
    id: 9,
    title: '长月烬明',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 8.3,
    episodes: 40,
    year: 2023,
    status: '已完结',
    actors: '罗云熙、白鹿、陈都灵、邓为',
    director: '鞠觉亮',
    description: '魔神澹台烬与正道曙光黎苏苏之间的宿命纠葛。为阻止魔神灭世，黎苏苏穿越时空回到五百年前，试图在魔神觉醒前将其诛杀，却陷入了一场爱恨交织的命运洪流。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20xianxia%20drama%20poster%20with%20two%20celestial%20beings%20in%20flowing%20robes%20floating%20among%20ancient%20Chinese%20architecture%20in%20clouds%2C%20ethereal%20lighting%2C%20peach%20blossom%20petals%2C%20soft%20pink%20and%20lavender%20tones%2C%20dreamlike%20fantasy%20atmosphere%2C%20traditional%20Chinese%20ink%20wash%20influence&width=600&height=800&seq=tv-cover-09&orientation=portrait',
    featured: false,
    tags: ['仙侠', '爱情', '古装', '虐恋'],
  },
  {
    id: 10,
    title: '非自然死亡',
    category: '日剧',
    categorySlug: 'riju',
    rating: 9.4,
    episodes: 10,
    year: 2018,
    status: '已完结',
    actors: '石原里美、井浦新、洼田正孝、市川实日子',
    director: '塚原亚由子',
    description: '在"非自然死亡原因研究所"工作的法医三澄美琴，与她的同事们一起，通过解剖遗体来探寻那些被掩盖的真相。每一个案件背后都隐藏着令人深思的社会问题。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20medical%20mystery%20drama%20poster%20with%20a%20determined%20female%20doctor%20in%20white%20coat%20standing%20in%20a%20modern%20autopsy%20room%2C%20clean%20minimalist%20composition%2C%20cool%20white%20and%20soft%20blue%20tones%2C%20clinical%20yet%20warm%20atmosphere%2C%20subtle%20dramatic%20lighting%2C%20professional%20medical%20aesthetic&width=600&height=800&seq=tv-cover-10&orientation=portrait',
    featured: false,
    tags: ['法医', '悬疑', '职场', '经典'],
  },
  {
    id: 11,
    title: '仙王的日常生活',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 7.8,
    episodes: 24,
    year: 2024,
    status: '更新中',
    actors: '孙路路、阎么么、星潮',
    director: '欧思嘉',
    description: '修真奇才王令在六岁时便已无敌于天下。为了过上平静的校园生活，他努力隐藏实力，做一个普通的高中生。然而各路强者纷纷找上门来，他的低调生活注定无法平静。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20anime%20poster%20with%20a%20teenage%20boy%20in%20school%20uniform%20revealing%20hidden%20glowing%20powers%2C%20dynamic%20action%20pose%2C%20colorful%20energy%20effects%2C%20modern%20school%20campus%20background%2C%20bright%20anime%20art%20style%2C%20energetic%20orange%20and%20cyan%20tones%2C%20shonen%20aesthetic&width=600&height=800&seq=tv-cover-11&orientation=portrait',
    featured: false,
    tags: ['搞笑', '校园', '修仙', '国漫'],
  },
  {
    id: 12,
    title: '鬼灭之刃：柱训练篇',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.9,
    episodes: 8,
    year: 2024,
    status: '更新中',
    actors: '花江夏树、鬼头明里、下野纮、松冈祯丞',
    director: '外崎春雄',
    description: '为了迎接与鬼舞辻无惨的最终决战，炭治郎和他的伙伴们在柱们的指导下开始了严酷的特训。每一位柱都传授着独特的技艺与战斗心得，为最终之战做最后的准备。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20poster%20with%20a%20young%20swordsman%20in%20traditional%20uniform%20wielding%20a%20katana%20under%20cherry%20blossoms%2C%20water%20breathing%20effects%20in%20blue%20waves%2C%20dynamic%20action%20composition%2C%20stunning%20ukiyo-e%20influence%2C%20vibrant%20blue%20and%20crimson%20tones%2C%20epic%20shonen%20battle%20aesthetic&width=600&height=800&seq=tv-cover-12&orientation=portrait',
    featured: false,
    tags: ['热血', '战斗', '日漫', '剧场版'],
  },
  {
    id: 13,
    title: '榴莲小姐',
    category: '泰剧',
    categorySlug: 'taiju',
    rating: 8.1,
    episodes: 16,
    year: 2024,
    status: '更新中',
    actors: 'Norraphat Vilaiphan、Ranchrawee Uakoolwarawat',
    director: 'Koo Ekkasit Trakulkasemsuk',
    description: '一个关于爱情、家庭与成长的温馨故事。年轻的女设计师在曼谷追逐梦想的过程中，遇见了改变她一生的人。甜蜜与酸涩交织，就像榴莲的味道一样令人难忘。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20Thai%20romantic%20drama%20poster%20with%20a%20young%20couple%20sitting%20together%20at%20a%20rooftop%20cafe%20in%20Bangkok%20at%20sunset%2C%20city%20skyline%20background%2C%20warm%20golden%20and%20coral%20tones%2C%20tropical%20atmosphere%2C%20soft%20romantic%20lighting%2C%20lifestyle%20aesthetic%20with%20gentle%20breeze%20effect&width=600&height=800&seq=tv-cover-13&orientation=portrait',
    featured: false,
    tags: ['爱情', '都市', '温馨', '成长'],
  },
  {
    id: 14,
    title: '黑袍纠察队第四季',
    category: '美剧',
    categorySlug: 'meiju',
    rating: 8.6,
    episodes: 8,
    year: 2024,
    status: '已完结',
    actors: '卡尔·厄本、杰克·奎德、安东尼·斯塔尔',
    director: '埃里克·克里普克',
    description: '世界正处于崩溃的边缘。Victoria Neuman比以往任何时候都更接近总统办公室，并受到祖国人的严密控制。Butcher只剩下几个月的生命，他必须找到新的方式来拯救世界。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20gritty%20superhero%20satire%20poster%20with%20a%20group%20of%20rugged%20non-superpowered%20vigilantes%20standing%20against%20a%20corrupt%20corporate%20superhero%2C%20urban%20decay%20background%2C%20dark%20satirical%20tone%2C%20muted%20red%20and%20gray%20color%20palette%2C%20anti-hero%20aesthetic%2C%20modern%20comic%20book%20style%20with%20realistic%20edge&width=600&height=800&seq=tv-cover-14&orientation=portrait',
    featured: true,
    tags: ['反超级英雄', '讽刺', '动作', '限制级'],
  },
  {
    id: 15,
    title: '与凤行',
    category: '国产剧',
    categorySlug: 'guochanju',
    rating: 8.4,
    episodes: 39,
    year: 2024,
    status: '已完结',
    actors: '赵丽颖、林更新、辛云来、何与',
    director: '邓科',
    description: '魔界女王沈璃在逃婚途中被打回凤凰原形，落难凡间被小贩行云买下。两人在命运的安排下展开了一段跨越三界的动人仙侠之恋，既有甜蜜日常也有生死考验。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20fantasy%20drama%20poster%20with%20a%20phoenix%20soaring%20above%20ancient%20celestial%20palace%2C%20a%20warrior%20woman%20in%20red%20flowing%20dress%20wielding%20a%20spear%2C%20dramatic%20clouds%20and%20golden%20light%2C%20warm%20crimson%20and%20gold%20tones%2C%20epic%20xianxia%20aesthetic%2C%20cinematic%20fantasy%20composition&width=600&height=800&seq=tv-cover-15&orientation=portrait',
    featured: false,
    tags: ['仙侠', '爱情', '喜剧', '热门'],
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国产剧', slug: 'guochanju' },
  { name: '韩剧', slug: 'hanju' },
  { name: '美剧', slug: 'meiju' },
  { name: '日剧', slug: 'riju' },
  { name: '泰剧', slug: 'taiju' },
  { name: '动漫', slug: 'dongman' },
];

export const featuredShows = tvSeries.filter(s => s.featured);
export const latestShows = [...tvSeries].sort((a, b) => b.year - a.year).slice(0, 8);
export const topRatedShows = [...tvSeries].sort((a, b) => b.rating - a.rating).slice(0, 8);

export const siteInfo = {
  name: '草民影院',
  description: '草民影院提供电视剧全集、最新电视剧、热门剧集，国产剧、韩剧、美剧在线观看，高清不卡，即点即看。',
  email: 'contact@caomin.tv',
  founded: '2020',
  slogan: '高清不卡，即点即看',
};